// Carry Roll FixablePriority — ranked correctable input deviations (emergent TODO-09).

import { useMemo } from 'react';
import { useRequest } from '../../store/selectors';
import { fixablePriority } from '@carry-roll/shared-logic';

export function FixablePriority() {
  const request = useRequest();
  const items = useMemo(() => fixablePriority(request), [request]);

  return (
    <div data-testid="fixable-priority">
      <h3 className="subsection-title">
        Close the gap
      </h3>
      <p className="text-xs mb-2" style={{ color: 'var(--color-text-muted)' }}>
        Ranked correctable inputs by expected carry gain, against the reference band for this club.
      </p>
      {items.length === 0 ? (
        <div className="text-sm" style={{ color: 'var(--color-success)' }}>
          All key inputs are inside their reference bands — no quick gains available.
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          {items.map((it) => (
            <div
              key={it.parameter}
              data-testid="fixable-priority-row"
              className="panel"
              style={{ padding: 'var(--space-2)' }}
            >
              <div className="flex justify-between">
                <span style={{ fontWeight: 'var(--fw-medium)' }}>
                  {it.parameter}
                </span>
                <span
                  style={{
                    color: 'var(--color-success)',
                    fontWeight: 'var(--fw-bold)',
                  }}
                >
                  +{it.expectedGainM} m
                </span>
              </div>
              <div className="text-xs" style={{ color: 'var(--color-text-muted)' }}>
                {it.deviation > 0 ? 'Above band by' : 'Below band by'}{' '}
                {Math.abs(it.deviation)} {it.unit}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
